import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PushPipe } from '@ngrx/component';
import { FunctionPipe } from '@wdx/shared/utils';
import { MoleculeInfoCardSearchModule } from '../../../components/molecules/molecule-info-card-search/molecule-info-card-search.module';
import { OrganismCaseTemplateSearchComponentDumb } from './components/organism-case-template-search-dumb/organism-case-template-search-dumb.component';
import { OrganismCaseTemplateSearchComponent } from './containers/organism-case-template-search/organism-case-template-search.component';

@NgModule({
    imports: [
        CommonModule,
        MoleculeInfoCardSearchModule,
        PushPipe,
        FunctionPipe,
    ],
    declarations: [
        OrganismCaseTemplateSearchComponent,
        OrganismCaseTemplateSearchComponentDumb,
    ],
    exports: [
        OrganismCaseTemplateSearchComponent,
        OrganismCaseTemplateSearchComponentDumb,
    ],
})
export class OrganismCaseTemplateSearchModule {}
